import { useNavigate } from "react-router-dom";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";

export const Toolbox = () => {
  const navigate = useNavigate();
  return (
    <nav>
      <div>
        <ToolboxButton
          icon={ToolboxButtonIcon.Back}
          tooltip="Glavni meni"
          toolbox={true}
          onClick={() => navigate('/dashboard')}
        />
      </div>
      <div>
        <ToolboxButton
          icon={ToolboxButtonIcon.Search}
          toolbox={true}
        />
        <ToolboxButton
          icon={ToolboxButtonIcon.Print}
          toolbox={true}
        />
      </div>
    </nav>
  );
};
